import { render, staticRenderFns } from "./SideBarRightHalf.vue?vue&type=template&id=7b4bde69&scoped=true"
import script from "./SideBarRightHalf.vue?vue&type=script&lang=js"
export * from "./SideBarRightHalf.vue?vue&type=script&lang=js"
import style0 from "./SideBarRightHalf.vue?vue&type=style&index=0&id=7b4bde69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4bde69",
  null
  
)

export default component.exports